import { GrowMetricsApiKey } from "@gymflow/types";
import { AxiosInstance } from "axios";

export type IntegrationApiKeyApiType = ReturnType<typeof integrationApiKeyApi>;
const integrationApiKeyApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  return {
    getGrowMetricsApiKeys() {
      return axiosInstance.get<GrowMetricsApiKey>(`${clubPrefix}integration-api-key/grow-metrics`);
    },
    deleteGrowMetricsApiKeys() {
      return axiosInstance.delete(
        `${clubPrefix}integration-api-key/grow-metrics`,
      );
    },
    postGrowMetricsApiKeys() {
      return axiosInstance.post<GrowMetricsApiKey>(
        `${clubPrefix}integration-api-key/grow-metrics`,
      );
    },
  };
};

export default integrationApiKeyApi;
